import Mmry from 'mmry';

export class ExpiringAggregateReadyCollection {
	private cacheStore: Mmry<boolean>;
	readonly DEFAULT_EXPIRY_TIME_IN_SECONDS = 10;

	constructor() {
		this.cacheStore = new Mmry<boolean>();
	}

	add(aggregateId: string): void {
		void this.cacheStore.put(aggregateId, true, `${this.DEFAULT_EXPIRY_TIME_IN_SECONDS} seconds`);
	}

	contains(aggregateId: string): boolean {
		return this.cacheStore.get(aggregateId) === true;
	}

	delete(aggregateId: string): void {
		void this.cacheStore.del(aggregateId);
	}
}
